import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-sm-12" }
const _hoisted_8 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "form-group col-sm-4" }
const _hoisted_12 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_SystemAccounts = _resolveComponent("SystemAccounts")!
  const _component_TraderAccounts = _resolveComponent("TraderAccounts")!
  const _component_UserAccounts = _resolveComponent("UserAccounts")!
  const _component_MerchantStoreAccounts = _resolveComponent("MerchantStoreAccounts")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "dashboardLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.selectTab(tab)), ["prevent"]),
                            class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === tab}])
                          }, _toDisplayString(_ctx.helper.trans(`admin.tab.${tab}`)), 11, _hoisted_9)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode(_component_LoaderWrapper, {
                  ref: "summaryLoader",
                  class: "h-100 mt-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (account) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_AccountWidget, {
                              "show-icon": "",
                              "hide-insurance": "",
                              account: account
                            }, null, 8, ["account"])
                          ])
                        ]))
                      }), 256))
                    ])
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            (_ctx.activeTabName === _ctx.Tabs.system)
              ? (_openBlock(), _createBlock(_component_SystemAccounts, { key: 0 }))
              : (_ctx.activeTabName === _ctx.Tabs.traders)
                ? (_openBlock(), _createBlock(_component_TraderAccounts, { key: 1 }))
                : (_ctx.activeTabName === _ctx.Tabs.teamleads)
                  ? (_openBlock(), _createBlock(_component_UserAccounts, {
                      key: 2,
                      role: _ctx.UserRole.TRADER_TEAM_LEAD
                    }, null, 8, ["role"]))
                  : (_ctx.activeTabName === _ctx.Tabs.merchants)
                    ? (_openBlock(), _createBlock(_component_MerchantStoreAccounts, { key: 3 }))
                    : (_ctx.activeTabName === _ctx.Tabs.referrals)
                      ? (_openBlock(), _createBlock(_component_UserAccounts, {
                          key: 4,
                          role: _ctx.UserRole.REFERRAL
                        }, null, 8, ["role"]))
                      : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}